"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FlatTreeItem", {
    enumerable: true,
    get: function() {
        return _FlatTreeItem.FlatTreeItem;
    }
});
const _FlatTreeItem = require("./FlatTreeItem");
